webpackJsonp([191],{

/***/ 1170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAppealDetail_vue__ = __webpack_require__(2843);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0bb17ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAppealDetail_vue__ = __webpack_require__(4822);
function injectStyle (ssrContext) {
  __webpack_require__(4820)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d0bb17ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderAppealDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0bb17ae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderAppealDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoPlayerDialog',
  props: {
    // 是否显示弹窗（支持 .sync）
    visible: {
      type: Boolean,
      default: false
    },
    // 视频 URL 列表
    videos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 打开时默认播放的视频索引
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      currentUrl: '',
      scale: 1,
      rotation: 0,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      instantReset: false,
      dragStartX: 0,
      dragStartY: 0,
      startTranslateX: 0,
      startTranslateY: 0,
      isPlaying: false,
      videoCurrentTime: 0,
      videoDuration: 0
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.currentIndex = Math.min(Math.max(this.index, 0), Math.max(this.videos.length - 1, 0));
        this.currentUrl = this.videos[this.currentIndex] || '';
        this.resetVideoState();
        this.$nextTick(function () {
          var wrapper = _this.$refs.videoDialogWrapper;
          wrapper && wrapper.focus();
        });
      }
    }
  },
  methods: {
    /**
     * 关闭弹窗时的清理
     */
    handleClose: function handleClose() {
      this.currentUrl = '';
      this.resetVideoState();
    },

    /**
     * ESC 关闭弹窗
     */
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },

    /**
     * 重置视频播放状态
     */
    resetVideoState: function resetVideoState() {
      this.scale = 1;
      this.rotation = 0;
      this.translateX = 0;
      this.translateY = 0;
      this.isDragging = false;
      this.isPlaying = false;
      this.videoCurrentTime = 0;
      this.videoDuration = 0;
    },

    /**
     * @param {string} url 视频地址
     */
    goToVideo: function goToVideo(url) {
      var _this2 = this;

      this.instantReset = true;
      this.currentUrl = url;
      this.resetVideoState();
      this.$nextTick(function () {
        _this2.instantReset = false;
      });
    },

    /**
     * 切换到上一个视频
     */
    prevVideo: function prevVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 切换到下一个视频
     */
    nextVideo: function nextVideo() {
      if (this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 点击缩略图直接播放指定视频
     * @param {number} i 视频索引
     */
    playVideoByIndex: function playVideoByIndex(i) {
      if (i === this.currentIndex) return;
      if (i < 0 || i >= this.videos.length) return;
      this.currentIndex = i;
      this.goToVideo(this.videos[i] || '');
    },

    /**
     * 视频滚轮缩放
     * @param {WheelEvent} e
     */
    onVideoWheel: function onVideoWheel(e) {
      var delta = e.deltaY > 0 ? -0.1 : 0.1;
      var newScale = this.scale + delta;
      newScale = Math.max(0.5, Math.min(5, newScale));
      this.scale = parseFloat(newScale.toFixed(2));
    },
    rotateVideo: function rotateVideo() {
      this.rotation += 90;
    },

    /**
     * 开始拖拽视频
     * @param {MouseEvent} e
     */
    onDragStart: function onDragStart(e) {
      if (e.button !== 0) return;
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.startTranslateX = this.translateX;
      this.startTranslateY = this.translateY;
    },

    /**
     * 拖拽中
     * @param {MouseEvent} e
     */
    onDragMove: function onDragMove(e) {
      if (!this.isDragging) return;
      this.translateX = this.startTranslateX + (e.clientX - this.dragStartX) / this.scale;
      this.translateY = this.startTranslateY + (e.clientY - this.dragStartY) / this.scale;
    },

    /**
     * 结束拖拽
     */
    onDragEnd: function onDragEnd() {
      this.isDragging = false;
    },

    /**
     * 切换播放/暂停
     */
    togglePlay: function togglePlay() {
      var video = this.$refs.videoPlayer;
      if (!video) return;
      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },

    /**
     * 视频播放进度更新
     */
    onTimeUpdate: function onTimeUpdate() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoCurrentTime = video.currentTime;
      }
    },

    /**
     * 视频元数据加载完成
     */
    onLoadedMeta: function onLoadedMeta() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoDuration = video.duration || 0;
      }
    },

    /**
     * 视频播放结束
     */
    onVideoEnded: function onVideoEnded() {
      this.isPlaying = false;
    },

    /**
     * 点击进度条跳转
     * @param {MouseEvent} e
     */
    seekVideo: function seekVideo(e) {
      var video = this.$refs.videoPlayer;
      var track = e.currentTarget;
      if (!video || !track || !this.videoDuration) return;
      var rect = track.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      video.currentTime = ratio * this.videoDuration;
      this.videoCurrentTime = video.currentTime;
    },

    /**
     * 格式化视频时间
     * @param {number} seconds
     * @returns {string}
     */
    formatVideoTime: function formatVideoTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) return '00:00';
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
  }
});

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1599);
function injectStyle (ssrContext) {
  __webpack_require__(1597)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1597:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("073a162c", content, true, {});

/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".video-player-dialog.el-dialog{background-color:rgba(0,0,0,.5);-webkit-box-shadow:none!important;box-shadow:none!important;margin:0!important;width:100%!important;height:100vh;border-radius:0}.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent!important}.video-player-dialog .el-dialog__header{padding:0}.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color .15s;transition:background-color .15s;z-index:2050}.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,.8)}.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px}.video-player-dialog .video-dialog-wrapper{-ms-flex-align:center;-ms-flex-pack:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden}.video-player-dialog .video-dialog-content,.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-align:center;-ms-flex-pack:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent!important}.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing}.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform .1s ease-out;transition:-webkit-transform .1s ease-out;transition:transform .1s ease-out;transition:transform .1s ease-out,-webkit-transform .1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent!important}.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none}.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer}.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:hsla(0,0%,100%,.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color .3s,opacity .3s;transition:background-color .3s,opacity .3s;z-index:10}.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff}.video-player-dialog .video-nav-arrow:hover{background-color:hsla(0,0%,100%,.4)}.video-player-dialog .video-nav-arrow.disabled{opacity:.3;cursor:not-allowed}.video-player-dialog .video-nav-arrow.disabled:hover{background-color:hsla(0,0%,100%,.2)}.video-player-dialog .video-nav-prev{left:12px}.video-player-dialog .video-nav-next{right:12px}.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity .2s;transition:opacity .2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px}.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:hsla(0,0%,100%,.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden}.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px}.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none}.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums}.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right}.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px}.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.3);border-radius:3px}.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:.7;-webkit-transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,transform .2s;transition:border-color .2s,opacity .2s,transform .2s,-webkit-transform .2s}.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)}.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1}.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000}", "", {"version":3,"sources":["/workspace/src/views/user-workinfo/components/VideoPlayerDialog.vue"],"names":[],"mappings":"AACA,+BAA+B,gCAAiC,kCAAmC,0BAA2B,mBAAoB,qBAAsB,aAAa,eAAe,CACnM,AACD,sCAAsC,UAAU,YAAY,sCAAuC,CAClG,AACD,wCAAwC,SAAS,CAChD,AACD,2CAA2C,eAAe,UAAU,YAAY,WAAW,YAAY,SAAS,gCAAiC,kBAAkB,gBAAgB,yCAA0C,iCAAkC,YAAY,CAC1Q,AACD,kGAAkG,+BAAgC,CACjI,AACD,6DAA6D,kBAAkB,YAAY,UAAU,WAAW,cAAc,CAC7H,AACD,2CAAyH,sBAAsB,AAA2C,qBAAqB,AAAuB,YAAY,kBAAkB,eAAe,aAAa,eAAe,CAC9S,AACD,sFAF2C,oBAAoB,oBAAoB,aAAa,yBAAyB,AAAsB,mBAAmB,wBAAwB,AAAqB,sBAAuB,CAGrO,AADD,2CAA2C,mBAAmB,WAAW,OAAO,AAA8E,sBAAsB,AAA2C,qBAAqB,AAAuB,oBAAoB,YAAY,qBAAqB,8BAA8B,sBAAsB,sCAAuC,CAC1Z,AACD,uDAAuD,wBAAwB,eAAe,CAC7F,AACD,8CAA8C,qBAAqB,kBAAkB,kDAAmD,0CAA2C,kCAAmC,iEAAoE,uCAAuC,+BAA+B,sCAAuC,CACtY,AACD,4DAA4D,wBAAwB,eAAe,CAClG,AACD,mCAAmC,gBAAgB,eAAe,+BAA+B,WAAW,YAAY,aAAa,6BAA6B,cAAc,cAAc,CAC7L,AACD,sCAAsC,kBAAkB,QAAQ,mCAAmC,2BAA2B,WAAW,YAAY,kBAAkB,oCAAuC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,oDAAuD,4CAA+C,UAAU,CACvgB,AACD,wCAAwC,eAAe,WAAW,4BAA4B,CAC7F,AACD,4CAA4C,mCAAsC,CACjF,AACD,+CAA+C,WAAY,kBAAkB,CAC5E,AACD,qDAAqD,mCAAsC,CAC1F,AACD,qCAAqC,SAAS,CAC7C,AACD,qCAAqC,UAAU,CAC9C,AACD,4CAA4C,kBAAkB,YAAY,SAAS,mCAAmC,2BAA2B,YAAY,UAAU,0BAA2B,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,eAAe,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC/a,AACD,yDAAyD,eAAe,WAAW,eAAe,oBAAoB,cAAc,+BAAgC,uBAAwB,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,iBAAiB,CACnb,AACD,4DAA4D,mBAAmB,WAAW,OAAO,WAAW,+BAAkC,kBAAkB,eAAe,kBAAkB,eAAe,CAC/M,AACD,kEAAkE,WAAW,iBAAiB,CAC7F,AACD,2DAA2D,YAAY,mBAAmB,sBAAsB,mBAAmB,CAClI,AACD,uDAAuD,eAAe,WAAW,mBAAmB,oBAAoB,cAAc,iCAAiC,CACtK,AACD,wDAAwD,eAAe,cAAc,mBAAmB,oBAAoB,cAAc,kCAAkC,eAAe,gBAAgB,CAC1M,AACD,uCAAuC,kBAAkB,SAAS,OAAO,QAAQ,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,iBAAiB,0BAA2B,gBAAgB,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC5W,AACD,0DAA0D,UAAU,CACnE,AACD,gEAAgE,8BAAiC,iBAAiB,CACjH,AACD,yDAAyD,mBAAmB,kBAAkB,cAAc,WAAW,YAAY,kBAAkB,gBAAgB,eAAe,6BAA6B,WAAY,sEAA2E,8DAAmE,sDAA2D,2EAAkF,CACvf,AACD,+DAA+D,UAAU,mCAAmC,0BAA0B,CACrI,AACD,gEAAgE,qBAAqB,SAAS,CAC7F,AACD,6EAA6E,WAAW,YAAY,oBAAoB,iBAAiB,cAAc,qBAAqB,CAC3K","file":"VideoPlayerDialog.vue","sourcesContent":["\n.video-player-dialog.el-dialog{background-color:rgba(0,0,0,0.5);-webkit-box-shadow:none !important;box-shadow:none !important;margin:0 !important;width:100% !important;height:100vh;border-radius:0\n}\n.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent !important\n}\n.video-player-dialog .el-dialog__header{padding:0\n}\n.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,0.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color 0.15s;transition:background-color 0.15s;z-index:2050\n}\n.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,0.8)\n}\n.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px\n}\n.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden\n}\n.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent !important\n}\n.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing\n}\n.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform 0.1s ease-out;transition:-webkit-transform 0.1s ease-out;transition:transform 0.1s ease-out;transition:transform 0.1s ease-out, -webkit-transform 0.1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent !important\n}\n.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none\n}\n.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer\n}\n.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:rgba(255,255,255,0.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color 0.3s, opacity 0.3s;transition:background-color 0.3s, opacity 0.3s;z-index:10\n}\n.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff\n}\n.video-player-dialog .video-nav-arrow:hover{background-color:rgba(255,255,255,0.4)\n}\n.video-player-dialog .video-nav-arrow.disabled{opacity:0.3;cursor:not-allowed\n}\n.video-player-dialog .video-nav-arrow.disabled:hover{background-color:rgba(255,255,255,0.2)\n}\n.video-player-dialog .video-nav-prev{left:12px\n}\n.video-player-dialog .video-nav-next{right:12px\n}\n.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,0.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity 0.2s;transition:opacity 0.2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px\n}\n.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:rgba(255,255,255,0.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden\n}\n.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px\n}\n.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none\n}\n.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums\n}\n.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right\n}\n.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,0.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.3);border-radius:3px\n}\n.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:0.7;-webkit-transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s, -webkit-transform 0.2s\n}\n.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)\n}\n.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1\n}\n.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"100%","top":"0px","modal":false,"append-to-body":"","custom-class":"video-player-dialog"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('div',{ref:"videoDialogWrapper",staticClass:"video-dialog-wrapper",attrs:{"tabindex":"-1"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.togglePlay($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"r",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.rotateVideo($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeDialog($event)}],"wheel":function($event){$event.preventDefault();return _vm.onVideoWheel($event)}}},[(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-prev",class:{ disabled: _vm.currentIndex === 0 },on:{"click":_vm.prevVideo}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"video-dialog-content",class:{ 'is-dragging': _vm.isDragging },on:{"mousedown":_vm.onDragStart,"mousemove":_vm.onDragMove,"mouseup":_vm.onDragEnd,"mouseleave":_vm.onDragEnd}},[_c('div',{staticClass:"video-transform-wrapper",class:{ 'no-transition': _vm.isDragging || _vm.instantReset },style:({ transform: ("scale(" + _vm.scale + ") translate(" + _vm.translateX + "px, " + _vm.translateY + "px) rotate(" + _vm.rotation + "deg)") })},[(_vm.currentUrl)?_c('video',{ref:"videoPlayer",staticClass:"video-player",attrs:{"src":_vm.currentUrl,"autoplay":""},on:{"timeupdate":_vm.onTimeUpdate,"loadedmetadata":_vm.onLoadedMeta,"play":function($event){_vm.isPlaying = true},"pause":function($event){_vm.isPlaying = false},"ended":_vm.onVideoEnded}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"custom-video-controls"},[_c('div',{staticClass:"control-btn",attrs:{"title":"播放/暂停（按 空格 键切换）"},on:{"click":_vm.togglePlay}},[(!_vm.isPlaying)?_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6 5 L19 12 L6 19 Z"}})]):_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"3","stroke-linecap":"round"}},[_c('line',{attrs:{"x1":"7","y1":"5","x2":"7","y2":"19"}}),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":"5","x2":"17","y2":"19"}})])]),_vm._v(" "),_c('div',{staticClass:"progress-track",on:{"click":_vm.seekVideo}},[_c('div',{staticClass:"progress-fill",style:({ width: _vm.videoDuration ? (_vm.videoCurrentTime / _vm.videoDuration * 100) + '%' : '0%' })})]),_vm._v(" "),_c('span',{staticClass:"time-text"},[_vm._v(_vm._s(_vm.formatVideoTime(_vm.videoCurrentTime))+" / "+_vm._s(_vm.formatVideoTime(_vm.videoDuration)))]),_vm._v(" "),_c('div',{staticClass:"control-btn",staticStyle:{"margin-left":"0"},attrs:{"title":"向右旋转（快捷键 R）"},on:{"click":_vm.rotateVideo}},[_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"9","y":"11","width":"11","height":"11","rx":"1.2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5 14 C5 10, 8 6, 14 6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 6 L11 4 M14 6 L11 8"}})])]),_vm._v(" "),_c('span',{staticClass:"scale-text",attrs:{"title":"通过滚轮控制缩放大小"}},[_vm._v(_vm._s((_vm.scale * 100).toFixed(0))+"%")])]),_vm._v(" "),(_vm.videos.length)?_c('div',{staticClass:"video-thumbnails"},_vm._l((_vm.videos),function(url,i){return _c('div',{key:i,staticClass:"video-thumb-item",class:{ active: i === _vm.currentIndex },on:{"click":function($event){return _vm.playVideoByIndex(i)}}},[_c('video',{staticClass:"video-thumb-player",attrs:{"src":url,"preload":"metadata","muted":"","playsinline":""},domProps:{"muted":true}})])}),0):_vm._e(),_vm._v(" "),(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-next",class:{ disabled: _vm.currentIndex === _vm.videos.length - 1 },on:{"click":_vm.nextVideo}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 2016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return orderAppealMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var orderAppealMixin = {
  data: function data() {
    return {
      appealStatusOptions: [{ label: '申诉中', value: 1 }, { label: '申诉成功', value: 2 }, { label: '申诉失败', value: 3 }, { label: '已撤回', value: 4 }, { label: '超时关闭', value: 5 }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({})),
  methods: {}
};

/***/ }),

/***/ 2843:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_order_mixins_order_appeal_mixins_js__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_user_workinfo_components_VideoPlayerDialog_vue__ = __webpack_require__(1575);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__views_order_mixins_order_appeal_mixins_js__["a" /* orderAppealMixin */]],
  components: { VideoPlayerDialog: __WEBPACK_IMPORTED_MODULE_3__views_user_workinfo_components_VideoPlayerDialog_vue__["a" /* default */] },
  data: function data() {
    return {
      loading: false,
      detail: {},
      viewer: null,
      videoDialogVisible: false,
      videoDialogVideos: [],
      videoDialogIndex: 0
    };
  },

  computed: {
    infoList: function infoList() {
      var d = this.detail || {};
      var status = Number(d.status);
      var rows = [{ key: '申诉ID', value: d.id != null ? d.id : '-' }, d.orderid ? { key: '工单ID', type: 'link', link: '/order/detail/' + d.orderid, value: 'ORD' + d.orderid } : { key: '工单ID', value: '-' }, { key: '申诉零工ID', value: d.userid != null ? d.userid : '-' }, { key: '申诉状态', type: 'tag', value: d.status }, { key: '客户名称/ID', value: (d.customer_name || '-') + ' / ' + (d.customerid || '-') }, { key: '项目名称/编号', value: (d.project_name || '-') + ' / ' + (d.project_number || '-') }, { key: '批次名称/编号', value: (d.batch_name || '-') + ' / ' + (d.batch_number || '-') }, { key: '任务ID', value: d.taskid != null ? d.taskid : '-' }, { key: '最后审核人', value: d.order_reviewer_id > 0 ? d.order_reviewer_name + ' / ' + d.order_reviewer_id : '' }, { key: '申诉处理人', value: d.audit_adminid > 0 ? d.audit_adminname + ' / ' + d.audit_adminid : '-' }, { key: '冻结零豆', value: d.frozen_point != null ? d.frozen_point : '-' }, { key: '补偿零豆', value: d.status === 2 ? d.compensate_point : '-' }, { key: '发起时间', value: d.created_at || '-' }, { key: '申诉处理时间', value: d.audited_at || '-' }, { key: '申诉原因', value: d.appeal_reason || '-' }];

      // status=2 申诉通过：展示实习生错审原因与通过备注
      if (status === 2) {
        rows.push({ key: '实习生错审原因', value: d.reviewer_wrong_reason != null ? d.reviewer_wrong_reason : '-' }, { key: '申诉通过备注', value: d.pass_remarks || '-' });
      }
      // status=3 申诉驳回：展示驳回原因与驳回备注
      if (status === 3) {
        rows.push({ key: '驳回原因', value: d.reject_reason != null ? d.reject_reason : '-' }, { key: '申诉驳回备注', value: d.reject_remarks || '-' });
      }
      return rows;
    }
  },
  created: function created() {
    this.fetchDetail();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.viewer) {
      this.viewer.destroy();
      this.viewer = null;
    }
  },

  methods: {
    getAppealStatusLabel: function getAppealStatusLabel(value) {
      var item = this.appealStatusOptions.find(function (i) {
        return i.value === value;
      });
      return item ? item.label : '未知';
    },
    getAppealStatusTag: function getAppealStatusTag(value) {
      var map = { 1: 'warning', 2: 'success', 3: 'danger', 4: 'info', 5: 'info' };
      return map[value] || 'info';
    },
    fetchDetail: function fetchDetail() {
      var _this = this;

      var id = this.$route.params.id;
      this.loading = true;
      return request.common('getOrderAppealDetail', { id: id }).then(function (res) {
        _this.detail = res.data || {};
      }).finally(function () {
        _this.loading = false;
      });
    },
    onViewPhotos: function onViewPhotos(index) {
      if (this.viewer) {
        this.viewer.destroy();
      }
      this.viewer = new __WEBPACK_IMPORTED_MODULE_1_viewerjs___default.a(document.getElementById('appealPhotoContainer'));
      this.viewer.view(index);
    },
    openVideoDialog: function openVideoDialog(url, index) {
      var videoList = (this.detail.appeal_materials || []).filter(function (m) {
        return m.type === 'video';
      }).map(function (m) {
        return m.url;
      });
      this.videoDialogVideos = videoList;
      this.videoDialogIndex = Math.max(videoList.indexOf(url), 0);
      this.videoDialogVisible = true;
    }
  }
});

/***/ }),

/***/ 4820:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4821);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("15b78ce5", content, true, {});

/***/ }),

/***/ 4821:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".blue-color[data-v-d0bb17ae]{color:#589df8;text-decoration:none}.empty-tip[data-v-d0bb17ae]{color:#909399;font-size:13px;padding:12px 0}.appeal-info-table[data-v-d0bb17ae]{font-size:14px}.table-detail-title[data-v-d0bb17ae]{color:#909399}.photo-view-image[data-v-d0bb17ae]{width:120px;height:120px;-o-object-fit:cover;object-fit:cover;cursor:pointer}.video-preview[data-v-d0bb17ae]{position:relative;cursor:pointer!important;background-color:#000}.log-time[data-v-d0bb17ae]{color:#909399;margin-right:8px}.log-list[data-v-d0bb17ae]{padding-left:8px}.log-item[data-v-d0bb17ae]{position:relative;padding:0 0 16px 20px;line-height:1.5}.log-item[data-v-d0bb17ae]:before{content:\"\";position:absolute;left:4px;top:7px;width:8px;height:8px;border-radius:50%;background:#c0c4cc;z-index:1}.log-item[data-v-d0bb17ae]:after{content:\"\";position:absolute;left:7px;top:15px;bottom:0;width:2px;background:#ebeef5}.log-item[data-v-d0bb17ae]:last-child{padding-bottom:0}.log-item[data-v-d0bb17ae]:last-child:after{display:none}", "", {"version":3,"sources":["/workspace/src/views/order/pages/OrderAppealDetail.vue"],"names":[],"mappings":"AACA,6BAA6B,cAAc,oBAAoB,CAC9D,AACD,4BAA4B,cAAc,eAAe,cAAc,CACtE,AACD,oCAAoC,cAAc,CACjD,AACD,qCAAqC,aAAa,CACjD,AACD,mCAAmC,YAAY,aAAa,oBAAoB,iBAAiB,cAAc,CAC9G,AACD,gCAAgC,kBAAkB,yBAA0B,qBAAqB,CAChG,AACD,2BAA2B,cAAc,gBAAgB,CACxD,AACD,2BAA2B,gBAAgB,CAC1C,AACD,2BAA2B,kBAAkB,sBAAsB,eAAe,CACjF,AACD,kCAAmC,WAAW,kBAAkB,SAAS,QAAQ,UAAU,WAAW,kBAAkB,mBAAmB,SAAS,CACnJ,AACD,iCAAkC,WAAW,kBAAkB,SAAS,SAAS,SAAS,UAAU,kBAAkB,CACrH,AACD,sCAAsC,gBAAgB,CACrD,AACD,4CAA6C,YAAY,CACxD","file":"OrderAppealDetail.vue","sourcesContent":["\n.blue-color[data-v-d0bb17ae]{color:#589df8;text-decoration:none\n}\n.empty-tip[data-v-d0bb17ae]{color:#909399;font-size:13px;padding:12px 0\n}\n.appeal-info-table[data-v-d0bb17ae]{font-size:14px\n}\n.table-detail-title[data-v-d0bb17ae]{color:#909399\n}\n.photo-view-image[data-v-d0bb17ae]{width:120px;height:120px;-o-object-fit:cover;object-fit:cover;cursor:pointer\n}\n.video-preview[data-v-d0bb17ae]{position:relative;cursor:pointer !important;background-color:#000\n}\n.log-time[data-v-d0bb17ae]{color:#909399;margin-right:8px\n}\n.log-list[data-v-d0bb17ae]{padding-left:8px\n}\n.log-item[data-v-d0bb17ae]{position:relative;padding:0 0 16px 20px;line-height:1.5\n}\n.log-item[data-v-d0bb17ae]::before{content:'';position:absolute;left:4px;top:7px;width:8px;height:8px;border-radius:50%;background:#c0c4cc;z-index:1\n}\n.log-item[data-v-d0bb17ae]::after{content:'';position:absolute;left:7px;top:15px;bottom:0;width:2px;background:#ebeef5\n}\n.log-item[data-v-d0bb17ae]:last-child{padding-bottom:0\n}\n.log-item[data-v-d0bb17ae]:last-child::after{display:none\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 4822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/order/appeal/table"}},[_vm._v("工单申诉管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("申诉详情 #"+_vm._s(_vm.$route.params.id))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("申诉信息")]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-table',{staticClass:"appeal-info-table",attrs:{"data":_vm.infoList,"show-header":false,"border":""}},[_c('el-table-column',{attrs:{"prop":"key","width":"150"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"table-detail-title"},[_vm._v(_vm._s(scope.row.key))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"min-width":"300"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.type === 'link')?_c('router-link',{staticClass:"blue-color",attrs:{"to":scope.row.link}},[_vm._v(_vm._s(scope.row.value))]):(scope.row.type === 'tag')?_c('el-tag',{attrs:{"type":_vm.getAppealStatusTag(scope.row.value),"size":"mini"}},[_vm._v(_vm._s(_vm.getAppealStatusLabel(scope.row.value)))]):_c('span',[_vm._v(_vm._s(scope.row.value))])]}}])})],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("申诉材料")]),_vm._v(" "),(_vm.detail.appeal_materials && _vm.detail.appeal_materials.length)?_c('div',{attrs:{"id":"appealPhotoContainer"}},_vm._l((_vm.detail.appeal_materials),function(m,i){return _c('div',{key:i,staticStyle:{"display":"inline-block","margin-right":"12px","vertical-align":"top"}},[(m.type === 'video')?_c('video',{staticClass:"photo-view-image video-preview",attrs:{"src":m.url,"preload":"metadata"},on:{"click":function($event){return _vm.openVideoDialog(m.url, i)}}}):(m.type === 'img')?_c('img',{staticClass:"photo-view-image",attrs:{"src":_vm._f("ossFormatJpg")(m.url),"alt":""},on:{"click":function($event){return _vm.onViewPhotos(i)}}}):_c('a',{attrs:{"href":m.url,"target":"_blank"}},[_vm._v(_vm._s(m.name || m.url))])])}),0):_c('div',{staticClass:"empty-tip"},[_vm._v("暂无材料")])],2),_vm._v(" "),_c('video-player-dialog',{attrs:{"visible":_vm.videoDialogVisible,"videos":_vm.videoDialogVideos,"index":_vm.videoDialogIndex},on:{"update:visible":function($event){_vm.videoDialogVisible=$event}}}),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("操作记录")]),_vm._v(" "),(_vm.detail.logs && _vm.detail.logs.length)?_c('div',{staticClass:"log-list"},_vm._l((_vm.detail.logs),function(log,i){return _c('div',{key:i,staticClass:"log-item"},[_c('span',{staticClass:"log-time"},[_vm._v(_vm._s(log.created_at))]),_vm._v(" "),_c('b',[_vm._v(_vm._s(log.operator_name || '-'))]),_vm._v(" "),(log.operator_id != null)?_c('span',[_vm._v("（"+_vm._s(log.operator_id)+"）")]):_vm._e(),_vm._v("：\n        "+_vm._s(log.msg)+"\n      ")])}),0):_c('div',{staticClass:"empty-tip"},[_vm._v("暂无记录")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/order-appeal-detail.39de5d3be72d0ff8faa4.js